import { render, staticRenderFns } from "./confirm-step-info.vue?vue&type=template&id=99350f4c&scoped=true&"
import script from "./confirm-step-info.vue?vue&type=script&lang=js&"
export * from "./confirm-step-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99350f4c",
  null
  
)

export default component.exports